import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {AppAction} from '../../appActions';
import {EmlPanelActionsEnum} from './emlPanelActions';
import {EmlPanelState} from './emlPanelState';

export function emlPanelReducer(state: EmlPanelState, action: AppAction): EmlPanelState {
  switch (action.type) {
    case EmlPanelActionsEnum.FETCH_EML_COMPLETED:
      return {
        ...state,
        status: AsyncStatusesEnum.LOADED,
        messageUid: action.payload.messageUid,
      };

    case EmlPanelActionsEnum.FETCH_EML_FAILED:
      return {
        ...state,
        status: AsyncStatusesEnum.FAILED,
        messageUid: undefined,
      };

    default:
      return state;
  }
}
